import React from 'react';
import AddProductVariantModal from '../components/AddProductVariantModal';
import VariantsTable from './VariantsTable';

const VariantsSection = ({ 
  enableVariants, 
  setEnableVariants, 
  isVariantModalOpen, 
  setIsVariantModalOpen,
  variantAttributes,
  selectedVariants,
  toggleVariantValue,
  isVariantValueSelected,
  generateVariants,
  showGeneratedVariants,
  generatedVariants, 
  setGeneratedVariants
}) => {
  return (
    <>
      <div className="sm:col-span-6">
        <div className="flex items-center justify-between py-4 border-t border-gray-200 mt-6">
          <div>
            <h3 className="text-base font-medium text-gray-900">Variantes de produit</h3>
            <p className="text-sm text-gray-500">Activez cette option si votre produit existe en plusieurs variantes (tailles, couleurs, etc.)</p>
          </div>
          <button
            type="button"
            className={`relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540] ${enableVariants ? 'bg-[#174540]' : 'bg-gray-200'}`}
            role="switch"
            aria-checked={enableVariants}
            onClick={() => setEnableVariants(!enableVariants)}
          >
            <span className="sr-only">Activer les variantes</span>
            <span
              className={`pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200 ${enableVariants ? 'translate-x-5' : 'translate-x-0'}`}
            />
          </button>
        </div>
      </div>

      {enableVariants && (
        <div className="sm:col-span-6 mt-4">
          <div className="flex items-center justify-between mb-4">
            <h4 className="text-sm font-medium text-gray-700">Configuration des variantes</h4>
            <button
              type="button"
              className="inline-flex items-center px-3 py-1.5 border border-[#174540] rounded-md text-sm font-medium text-[#174540] bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#174540]"
              onClick={() => setIsVariantModalOpen(true)}
            >
              <svg className="h-5 w-5 mr-1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              Configurer les variantes
            </button>
          </div>

          {/* Variant Modal */}
          <AddProductVariantModal
            isOpen={isVariantModalOpen}
            onClose={() => setIsVariantModalOpen(false)}
            variantAttributes={variantAttributes}
            selectedVariants={selectedVariants}
            toggleVariantValue={toggleVariantValue}
            isVariantValueSelected={isVariantValueSelected}
            generateVariants={generateVariants}
          />

          {/* Generated Variants Table */}
          {showGeneratedVariants && generatedVariants.length > 0 && (
            <VariantsTable 
              generatedVariants={generatedVariants} 
              setGeneratedVariants={setGeneratedVariants} 
            />
          )}
        </div>
      )}
    </>
  );
};

export default VariantsSection;